import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IRequisitionState } from './requisition.types';
import { IRequisitionData, IUserData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IRequisitionState = {
  version: 1,
  requisitions: [] as IRequisitionData[],
  lastCreatedRequisitionId: null as null | number,
  lastCreatedRequisitionCommentId: null,
  count: 0,
  approvers: [] as IUserData[],
  buyers: [] as IUserData[],
  activities: [],
  comments: [],
  mentionableUsers: [] as IUserData[],

  lastPromise: null
};

const namespaced = true;

export const requisition: Module<IRequisitionState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
